import ajoutOrdre from '@/services/devisCommandes/ajoutOrdre';
import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';

export default function genererLigneCommande(index) {
  const ligne = {
    ordre: null,
    produit: null,
    produitId: null,
    tarif: null,
    libelle: null,
    quantite: null,
    uniteVente: null,
    prixUnitaire: null,
    totalAvantRemise: null,
    remise: null,
    typeRemise: null,
    tauxTva: null,
    totalHt: null,
    devisCommande: null,
    type: null,
    referenceEcheancier: null,
    referencePersonnalise: null,
    lignesRemise: [],
    masqueLigne: false,
    etatDeLaDemande: false,
    // La variable 'search' est utlisée pour la recherche dans l'autocomplet de la ligne de commande
    search: null,
    totalHtAvecLigneRemise: null,
    selected: false,
    lignesCommande: [],
    modeCalculHonoraire: genererModeCalculHonoraire(),
  };
  if (index !== null) {
    ajoutOrdre(ligne, index);
  }
  return ligne;
}
